import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  property: [],
};

const singlePropertySlice = createSlice({
  name: "singleProperty",
  initialState,
  reducers: {
    setProperty: (state, action) => {
      state.property = action.payload;
    },
    clearProperty: (state) => {
      state.property = null;
    },
  },
});

export const { setProperty, clearProperty } = singlePropertySlice.actions;

export const selectProperty = (state) => state.singleProperty.property;

export default singlePropertySlice.reducer;
